import { render, staticRenderFns } from "./InscribeteCesfamView.vue?vue&type=template&id=8b8a1ed8"
import script from "./InscribeteCesfamView.vue?vue&type=script&lang=ts"
export * from "./InscribeteCesfamView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports